import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { CrudService } from '../../shared/services/crud.service';
import { KeyValuePair } from '../../shared/shared.types';
import { EmailInterpolation, EmailTemplate } from './email-template.type';

@Injectable({
    providedIn: 'root'
})
export class EmailTemplateService extends CrudService<EmailTemplate> {
    constructor(protected http: HttpClient) {
        super(http, 'emailTemplate');
    }

    interpolate(id: number, obj: EmailInterpolation): Observable<any> {
        return this.http.post(`/api/${this.apiUrl}/${id}/interpolate`, obj);
    }

    sendTestEmail(id: number, obj: any): Observable<EmailTemplate> {
        return this.http.post<EmailTemplate>(`/api/${this.apiUrl}/${id}/sendTestEmail`, obj);
    }

    getTags(id: string | number, alias: string): Observable<Array<KeyValuePair>> {
        return this.http.get<Array<KeyValuePair>>(`/api/${this.apiUrl}/${id}/tags?alias=${alias}`);
    }

    previewInterpolation(id: string | number, alias: string): Observable<any> {
        return this.http.get<any>(`/api/${this.apiUrl}/${id}/previewInterpolation?alias=${alias}`);
    }
}
